import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IToaNhaReducer } from "../../reducer-model/category/IToaNhaReducer";
import { IToaNhaActionTypes } from "../../action-types/category/IToaNhaActions";

const initState: IToaNhaReducer = {
  status: eReducerStatusBase.is_not_initialization,
  toaNhas: [],
};

export const toaNhaReducer = (
  state: IToaNhaReducer = initState,
  action: IToaNhaActionTypes
): IToaNhaReducer => {
  switch (action.type) {
    case "TOA_NHA_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "TOA_NHA_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        toaNhas: action.payload,
      };
    case "TOA_NHA_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "TOA_NHA_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        toaNhaEditing: action.payload,
      };
    case "TOA_NHA_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "TOA_NHA_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "TOA_NHA_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "TOA_NHA_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "TOA_NHA_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "TOA_NHA_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "TOA_NHA_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
